import {
  DEBRIEFS_FETCH,
  DEBRIEFS_FETCH_SUCCESS,
  DEBRIEFS_FETCH_FAILURE,
  DEBRIEF_FETCH,
  DEBRIEF_FETCH_SUCCESS,
  DEBRIEF_FETCH_FAILURE,
  OBJECTIVES_FETCH,
  OBJECTIVES_FETCH_SUCCESS,
  OBJECTIVES_FETCH_FAILURE,
} from "../actionTypes";

const INITIAL_STATE = {
  debriefs: [],
  currentDebrief: null,
  objectives: [],
  loading: false,
  error: null,
};

export default function DebriefReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case DEBRIEFS_FETCH:
      return { ...state, loading: true, error: null };
    case DEBRIEFS_FETCH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        debriefs: payload,
        loading: false,
        error: null,
      };
    }
    case DEBRIEFS_FETCH_FAILURE: {
      const { payload } = action;
      return { ...state, loading: false, error: payload };
    }
    case DEBRIEF_FETCH:
      return { ...state, currentDebrief: null, loading: true, error: null };
    case DEBRIEF_FETCH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        currentDebrief: payload,
        loading: false,
        error: null,
      };
    }
    case DEBRIEF_FETCH_FAILURE: {
      const { payload } = action;
      return { ...state, loading: false, error: payload };
    }
    case OBJECTIVES_FETCH:
      return { ...state, loading: true, error: null };
    case OBJECTIVES_FETCH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        objectives: payload,
        loading: false,
        error: null,
      };
    }
    case OBJECTIVES_FETCH_FAILURE: {
      const { payload } = action;
      return { ...state, loading: false, error: payload };
    }
    default:
      return state;
  }
}
